<mood-admin-config-fieldset class="color-scale-form" legendTitle="Colorscale configuration">
  <div class="description">
    <p>
      The color scale configured here will be used as the default color scale for the raster layers. A user can still
      adjust the color scale if they wish. If no value is specified, the Viridis color scale will be used.
    </p>
  </div>

  <mat-form-field class="form-field">
    <mat-label>Color scale</mat-label>
    <input type="text" matInput [formControl]="colorScaleControl" [matAutocomplete]="colorPicker" />

    <mat-autocomplete #colorPicker="matAutocomplete" (optionSelected)="selectColorScale($event)"
      [displayWith]="displayColorScale">
      <mat-option *ngFor="let scale of filteredColorScales | async" [value]="scale">
        <div class="option">
          <span class="label">{{ scale.name }}</span>
          <span class="spacer"></span>
          <div class="colorscale">
            <div *ngFor="let color of scale.colors" [style.background-color]="color" class="color">
            </div>
          </div>
        </div>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <div [formGroup]="formGroupContainer" class="slide-control">
    <mat-slide-toggle formControlName="invert"></mat-slide-toggle>
    <mat-label class="slide-label">Invert scale</mat-label>
  </div>
</mood-admin-config-fieldset>
